﻿import { Decorators } from "@serenity-is/corelib";

export enum CustomDateSourceData {
    AccountHoldings = 1,
    Ownership = 2,
    Price = 3
}
Decorators.registerEnumType(CustomDateSourceData, 'Matrix.Data.CustomDateSourceData');